<template>
  <container>
    <row class="mt-5 align-items-center justify-content-start">
      <h4 style="margin: 0" class="grey-text"><strong>Time Picker</strong></h4>
      <a href="https://mdbootstrap.com/vue/advanced/timepicker/?utm_source=DemoApp&utm_medium=MDBVuePro" waves-fixed class="border grey-text px-2 border-light rounded ml-2" target="_blank"><fa icon="graduation-cap" class="mr-2"/>Docs</a>
    </row>
    <hr class="mb-4" />
    <container class="ml-5 mt-5">
      <row>
        <column col="6">
          <time-picker
            :id="'timePickerOne'"
            :placeholder="'Select your time'"
            :label="'format: am/pm'"
            :color="'secondary-color'"
          />
        </column>
        <column col="6">
          <time-picker
            :id="'timePickerTwo'"
            :placeholder="'Select your time'"
            :label="'format: 24h'"
            :hoursFormat="24"
          />
        </column>
      </row>
    </container>
  </container>
</template>

<script>
import {  TimePicker, Container, Row, Column, Fa } from 'mdbvue';

export default {
  name: 'TimePickerPage',
  data() {
    return {
      value: null,
      picker: null,
    };
  },
  components: {
    TimePicker,
    Container,
    Row,
    Column,
    Fa
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
